import { PAGINGATION_DEFAULT } from '@const/pagination'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import moment from 'moment'
import { fetchWebNotificationList, fetchSingle } from './asyncAction'

const initialState: TWebNotificationManagement.TState = {
  notificationList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  isFetchingNotificationList: true,
  notificationDetail: {
    data: {
      id: '',
      content: '',
      isActive: true,
      linkText: '',
      linkUrl: '',
      publishTargets: [],
      enqueueTime: null,
      canSchedule: false,
      enqueueDate: '',
      enqueueHour: 9,
      status: 0,
      notificationLinks: []
    }
  },
  targets: [
    { name: 'ユーザーweb向け(ヘッダー）',
      isSelected: false,
      id: 0
    },
    {
      name: 'ユーザーweb向け(帯）',
      isSelected: false,
      id: 1
    }],
  isLoading: false,
  errors: [
    { key: 'target', message: '' },
    { key: 'type', message: '' },
    { key: 'content', message: '' },
    { key: 'linkText', message: '' },
    { key: 'linkUrl', message: '' },
    { key: 'enqueueTime', message: '' }
  ]
}
const webNotificationManagementSlice = createSlice({
  name: 'webNotificationManagement',
  initialState,
  reducers: {
    changeLinkText (state, action) {
      state.notificationDetail.data.linkText = action.payload
    },
    changeLinkUrl (state, action) {
      state.notificationDetail.data.linkUrl = action.payload
    },
    resetAddData () {
      return initialState
    },
    changeTarget (state, action) {
      const { id, isSelected } = action.payload
      const target = state.targets.filter(x => x.id === id)[0]
      target.isSelected = isSelected
      state.notificationDetail.data.publishTargets = state.targets.filter(x => x.isSelected).map(x => x.id)
    },
    handleChangeInsertMessage (state, action) {
      state.notificationDetail.data.content = action.payload.content
    },
    addError (state, action) {
      const { key, message } = action.payload
      const errors = state.errors
      const updatedError = errors.filter(x => x.key === key)[0]
      if (updatedError) {
        updatedError.message = message
      }
    },
    setIsLoading (state, action) {
      state.isLoading = action.payload
    },
    showFullContent (state, action) {
      const notificationItem = state.notificationList.data.filter(x => x.id === action.payload)[0]
      if (notificationItem) {
        notificationItem.content = notificationItem.fullContent
      }
    },
    resetFormValue (state) {
      state.notificationDetail = initialState.notificationDetail
      state.targets = initialState.targets
    },
    changeIsActive (state, action) {
      state.notificationDetail.data.isActive = action.payload
    },
    setEnqueueDate (state, action) {
      const enqueueDateTimeValue = new Date(action.payload)
      enqueueDateTimeValue.setHours(state.notificationDetail.data.enqueueHour)
      state.notificationDetail.data.enqueueTime = moment(enqueueDateTimeValue).format()
      state.notificationDetail.data.enqueueDate = moment(action.payload).format('YYYY-MM-DD')
    },
    setEnqueueTime (state, action) {
      const { enqueueTime } = state.notificationDetail.data
      if (enqueueTime) {
        const enqueueDateTimeValue = new Date(enqueueTime)
        enqueueDateTimeValue.setHours(action.payload)
        state.notificationDetail.data.enqueueTime = moment(enqueueDateTimeValue).format()
      }
    },
    setCanSchedule (state, action) {
      state.notificationDetail.data.canSchedule = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchWebNotificationList.fulfilled, (state, action: PayloadAction<TWebNotificationManagement.TState['notificationList']>) => {
        if (!action.payload?.data) return
        state.notificationList = {
          ...action.payload
        }
        state.isFetchingNotificationList = false
      })
      .addCase(fetchWebNotificationList.pending, state => {
        state.isFetchingNotificationList = true
      })
    builder
      .addCase(fetchSingle.fulfilled, (state, action: PayloadAction<TWebNotificationManagement.TState['notificationDetail']>) => {
        if (!action.payload) return
        state.isLoading = false
        const { enqueueTime } = action.payload.data
        if (enqueueTime) {
          const dateTimeValue = new Date(enqueueTime)
          action.payload.data.enqueueDate = moment(dateTimeValue).format('YYYY-MM-DD')
          action.payload.data.enqueueHour = dateTimeValue.getHours()
        } else {
          action.payload.data.enqueueHour = 9
        }

        action.payload.data.publishTargets.forEach(item => {
          const target = state.targets.filter(x => x.id === item)[0]
          target.isSelected = true
        })
        action.payload.data.publishTargets = state.targets.filter(x => x.isSelected).map(x => x.id)
        action.payload.data.linkText = action.payload.data.notificationLinks[0]?.text ?? ''
        action.payload.data.linkUrl = action.payload.data.notificationLinks[0]?.url ?? ''
        state.notificationDetail = action.payload
      })
      .addCase(fetchSingle.pending, state => {
        state.isLoading = true
      })
  }
})

export * from './asyncAction'

export const {
  changeLinkText,
  changeLinkUrl,
  resetAddData,
  changeTarget,
  addError,
  handleChangeInsertMessage,
  setIsLoading,
  showFullContent,
  resetFormValue,
  changeIsActive,
  setEnqueueTime,
  setEnqueueDate,
  setCanSchedule
} = webNotificationManagementSlice.actions

export const webNotificationManagementReducer = webNotificationManagementSlice.reducer
